export const vanliferPages = [
    {
        title: 'Reiseplanung',
        href: '/vanlifer/TravelPlanning',
    },
    {
        title: 'Reiseziele',
        href: '/vanlifer/regions',
    },
    {
        title: 'Meine Reisen',
        href: '/vanlifer/BookingOverview',
    },
    {
        title: 'Community Profil',
        href: '/vanlifer/Community/Profile',
    },
    {
        title: 'Einstellungen',
        href: '/profil/personal',
    }
];

export const hostPages = [
    {
        title: 'Startseite',
        href: '/host/HostOverview',
    },
    {
        title: 'Verfügbarkeiten',
        href: '/host/SitesManagement',
    },
    {
        title: 'Mein Betrieb',
        href: '/host/Compounds',
    },
    {
        title: 'Einstellungen',
        href: '/profil/abos',
    }];

export const agentPages = [
    {
        title: 'User',
        href: '/travelAgent/AgentUserOverview',
    },
    {
        title: 'Compounds',
        href: '/travelAgent/AgentCompoundOverview',
        children: [
            {
                title: 'Übersicht',
                href: '/travelAgent/AgentCompoundOverview',
            },
            {
                title: 'Kurationen',
                href: '/travelAgent/AgentCompoundOverview/CurationsOverview',
            },
            {
                title: 'Labels/Awards',
                href: '/travelAgent/AgentCompoundOverview/LabelsOverview',
            }
        ]
    },
    {
        title: 'Touren',
        href: '/travelAgent/AgentTourOverview',
    },
    {
        title: 'Products',
        href: '/travelAgent/Products',
        children: [
            {
                title: 'Suchmasken für Reisen',
                href: '/travelAgent/Products',
            }
        ]
    },
];
